import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp } from "react-icons/fa";

const SOCIAL_LINKS = [
    {
        label: "Instagram",
        href: "https://www.instagram.com/beachbumfredfl/",
        Icon: FaInstagram,
        className: "is-instagram",
    },
    {
        label: "Facebook",
        href: "https://www.facebook.com/profile.php?id=61590719576284/",
        Icon: FaFacebookF,
        className: "is-facebook",
    },
    {
        label: "TikTok",
        href: "https://www.tiktok.com/@beachbumpass",
        Icon: FaTiktok,
        className: "is-tiktok",
    },
    {
        label: "WhatsApp",
        href: "https://wa.me/18503766033?text=Hi%20Beach%20Bum%20Pass%21%20I%20have%20a%20question.",
        Icon: FaWhatsapp,
        className: "is-whatsapp",
    },
];

export default function SocialLinks({
    variant = "default",
    showText = true,
    className = "",
    onSocialClick,
}) {
    const classes = ["bbp-socials", `bbp-socials--${variant}`, className]
        .filter(Boolean)
        .join(" ");

    return (
        <nav className={classes} aria-label="Beach Bum Pass social links">
            {SOCIAL_LINKS.map(({ label, href, Icon, className: socialClass }) => (
                <a
                    key={label}
                    className={`bbp-social-link ${socialClass}`}
                    href={href}
                    target="_blank"
                    rel="noreferrer noopener"
                    aria-label={`Follow Beach Bum Pass on ${label}`}
                    onClick={() => onSocialClick?.(label.toLowerCase())}
                >
                    <span className="bbp-social-link__badge" aria-hidden="true">
                        <Icon />
                    </span>

                    {showText && <span className="bbp-social-link__text">{label}</span>}
                </a>
            ))}
        </nav>
    );
}